import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { PortalState } from '@view-models/enums/portal-state';
import { BatchDetailStore } from '../../batch-detail.store';
import { EsvrTransportInformationComponent } from '../esvr-transport-information/esvr-transport-information.component';
import { DoCheck, KeyValueDiffers, KeyValueDiffer } from '@angular/core';
import { VehicleType } from '@services/cleanfill-api/cleanfill-api.generated';

enum LoadTypes {
  Twenty = 20,
  ThirtySeven = 37,
}
enum PopulateFields {
  TareWeight = 'TareWeight',
  GrossWeight = 'GrossWeight',
  NetWeight = 'NetWeight'
}
interface ShowOther {
  tareWeight: boolean;
  grossWeight: boolean;
}


@Component({
  selector: 'app-esvr-weight-placement-location',
  templateUrl: './esvr-weight-placement-location.component.html',
  styleUrls: ['./esvr-weight-placement-location.component.scss'],
})
export class EsvrWeightPlacementLocationComponent implements OnInit {
  loadTypes: LoadTypes[];
  @Input() portalState: PortalState;
  @Input() submited: boolean;
  @Input() allowPostEdit: boolean;
  @Input() editing: boolean;
  PortalState = PortalState;

  showOther: ShowOther;

  constructor(public formRef: ControlContainer, private batchLoad: BatchDetailStore) {
    this.showOther = { tareWeight: false, grossWeight: false };
  }

  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }

  ngOnInit() {
    this.resetFields();

    this.loadTypes = Object.keys(LoadTypes)
      .filter((key) => isNaN(Number(key)))
      .map((p) => {
        return LoadTypes[p];
      });

    this.batchLoad.esvr$.subscribe((res) => {
      if (res) {
        if (!this.editing) { // first load
          if (res.vehicleType) {
            const loadValue = res.vehicleType === 'Triaxle' ? LoadTypes.Twenty : LoadTypes.ThirtySeven;
            const vehicleWeight = EsvrTransportInformationComponent.stVehicleWeight;
            const tareWeight = this.formGroup?.get('tareWeight').value;

            if ((!tareWeight || tareWeight <= 0) && vehicleWeight && vehicleWeight > 0) {
              (this.formGroup as FormGroup).controls.tareWeight.setValue(vehicleWeight);
            }

            setTimeout(() => {
              this.formRef.control.patchValue({ volumeLoad: loadValue });
              this.formRef.control.updateValueAndValidity();
            });
          }
        } else { // editing mode
          if (res.vehicleType) {
            const loadValue = res.vehicleType === 'Triaxle' ? LoadTypes.Twenty : LoadTypes.ThirtySeven;
            if (loadValue > 0) {
              let tareWeight = this.getFieldValue('tareWeight');
              let grossWeight = this.getFieldValue('grossWeight');

              if (tareWeight && tareWeight > 0) {
                grossWeight = tareWeight + loadValue;
              } else if (grossWeight && grossWeight > 0 && grossWeight - loadValue > 0) {
                tareWeight = grossWeight - loadValue;
              } else {
                tareWeight = 0;
                grossWeight = loadValue;
              }

              (this.formGroup as FormGroup).controls.grossWeight.setValue(grossWeight);
              (this.formGroup as FormGroup).controls.tareWeight.setValue(tareWeight);
            }
          }
        }
      }
    });

    this.showOther = { tareWeight: false, grossWeight: false };
  }

  getFieldValue(field: string) {
    return this.formGroup?.get(field).value;
  }

  markAsPrestine() {
    this.formGroup.markAsPristine();
    this.formGroup.markAsUntouched();
  }

  resetFields() {
    (this.formGroup as FormGroup).controls.tareWeight.setValue(0);
    (this.formGroup as FormGroup).controls.grossWeight.setValue(0);
  }
}
